import { ServiceData } from '../service';
import db from '../index';
import { DataOwner } from '../dataOwner';
import { entityServiceFactory } from '../entityServiceFactory';

export interface ProjectsServiceData extends ServiceData {}
/** Data of the user: valid in every project. */
const { owner, add, clear, stopDownloading, get, reset, requestDownloadAgain } = entityServiceFactory<ProjectsServiceData>(db, 'projectsService', {
  owner: DataOwner.USER,
});

export { owner, add, clear, stopDownloading, get, reset, requestDownloadAgain };
